export default "__VITE_ASSET__BhmgvVQb__"